'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexWrap', 'wrap', 'wrap');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex-wrap.js
// module id = 375
// module chunks = 168707334958949